import PatientReview from "./PatientReview";
import OneSocketPatientReview from "./OneSocketPatientReview";
import "./review.scss";
import FormTitle from "../components/formTitle/FormTitle";
import DefinitiveReview from "./DefinitiveReview";
import DesignLinerReviewBilateral from "./DesignLinerReviewBilateral";

const BilateralOrderReview = ({
  forms,
  handleNext,
  handleBack,
  currentIndex,
}) => {
  let designerLinerFormAdded = false
  return (
    <div>
      <div className="biletralReview">
        <div className="bilateralReviewTitle">
          <FormTitle
            title="Order Review"
            description=""
          />
        </div>
        {forms.map((item, index) => {
          if (item.id === "3" || item.id === "4") {
            return (
              <PatientReview
                isBilateral={true}
                formTypeId={parseInt(item.id)}
                bilateralName={forms[0].name + " + " + forms[1].name}
                name={forms[0].name}
                orderNumber={index + 1}
                showOrderInfo={index === 0 ? true : false}
                showOrderSummary={index === 0 ? false : true}
                handleNext={handleNext}
                handleBack={handleBack}
                currentIndex={currentIndex}
              />
            );
          } else if (item.id === "5" || item.id === "6") {
            return (
              <DefinitiveReview
                isBilateral={true}
                formTypeId={parseInt(item.id)}
                bilateralName={forms[0].name + " + " + forms[1].name}
                name={forms[0].name}
                orderNumber={index + 1}
                showOrderInfo={index === 0 ? true : false}
                showOrderSummary={index === 0 ? false : true}
                handleNext={handleNext}
                handleBack={handleBack}
                currentIndex={currentIndex}
              />
            );
          } else if (item.id === "7" || item.id === "8") {
            return (
              <OneSocketPatientReview
                isBilateral={true}
                formTypeId={parseInt(item.id)}
                bilateralName={forms[0].name + " + " + forms[1].name}
                name={forms[0].name}
                orderNumber={index + 1}
                showOrderInfo={index === 0 ? true : false}
                showOrderSummary={index === 0 ? false : true}
                handleNext={handleNext}
                handleBack={handleBack}
                currentIndex={currentIndex}
              />
            );
          } else if (item.id === "23") {
            if (!designerLinerFormAdded) {
              designerLinerFormAdded = true;
              return (
                <DesignLinerReviewBilateral
                  isBilateral={true}
                  formTypeId={parseInt(item.id)}
                  bilateralName={forms[0].name + " + " + forms[1].name}
                  formName="Design Liner Review"
                  orderNumber={index + 1}
                  showOrderSummary={true}
                  handleNext={handleNext}
                  handleBack={handleBack}
                  currentIndex={currentIndex}
                  formIndex={[0, 1]}
                  uniqueId={null}
                />
              );
            } else {
              return <></>
            }
          } else {
            return null;
          }
        })}
      </div>

      {/* {formId === 3 || 4 ? <PatientReview /> : ""}

      {formId === 5 || 6 ? <DefinitiveSocketReview /> : ""}

      {formId === 7 || 8 ? <OneSocketPatientReview /> : ""} */}
    </div>
  );
};

export default BilateralOrderReview;
